
<div>
  <div class="survey-menu my-3">
    <cvt-button 
      text="Configure Survey"
      @click="toggleSurvey"  
    ></cvt-button>
  </div>
</div>
